"use strict";
// Constants
Object.defineProperty(exports, "__esModule", { value: true });
exports.cssVars = exports.Positions = exports.Patterns = exports.Colors = exports.Breakpoints = exports.breakpointsArray = exports.IconNames = void 0;
var IconNames;
(function (IconNames) {
    IconNames["shape"] = "shape";
})(IconNames = exports.IconNames || (exports.IconNames = {}));
var gutter = 30;
exports.breakpointsArray = [0, 576, 767, 980, 1136, 1320];
var Breakpoints;
(function (Breakpoints) {
    Breakpoints[Breakpoints["xs"] = exports.breakpointsArray[0]] = "xs";
    Breakpoints[Breakpoints["sm"] = exports.breakpointsArray[1]] = "sm";
    Breakpoints[Breakpoints["md"] = exports.breakpointsArray[2]] = "md";
    Breakpoints[Breakpoints["lg"] = exports.breakpointsArray[3]] = "lg";
    Breakpoints[Breakpoints["xl"] = exports.breakpointsArray[4]] = "xl";
    Breakpoints[Breakpoints["xxl"] = exports.breakpointsArray[5]] = "xxl";
})(Breakpoints = exports.Breakpoints || (exports.Breakpoints = {}));
var breakpoints = {
    xs: Breakpoints.xs,
    sm: Breakpoints.sm,
    md: Breakpoints.md,
    lg: Breakpoints.lg,
    xl: Breakpoints.xl,
    xxl: Breakpoints.xxl,
};
var Dist;
(function (Dist) {
    Dist[Dist["xxs"] = 10] = "xxs";
    Dist[Dist["xs"] = 15] = "xs";
    Dist[Dist["sm"] = 20] = "sm";
    Dist[Dist["md"] = 30] = "md";
    Dist[Dist["lg"] = 52] = "lg";
    Dist[Dist["xl"] = 78] = "xl";
    Dist[Dist["xxl"] = 100] = "xxl";
    Dist[Dist["xxxl"] = 160] = "xxxl";
})(Dist || (Dist = {}));
var Colors;
(function (Colors) {
    Colors["primary"] = "#121037";
    Colors["secondary"] = "#EB6012";
    Colors["tertiary"] = "#E3E6E5";
    Colors["quaternary"] = "#009DDF";
    Colors["quinary"] = "#FFD500";
    Colors["senary"] = "#009d82";
    Colors["error"] = "#e40428";
    Colors["background"] = "#FAF9F9";
    Colors["border"] = "#E3E6E5";
    Colors["tableBorder"] = "#BFC5D2";
    Colors["text"] = "#121037";
    Colors["white"] = "#ffffff";
    Colors["black"] = "#000000";
})(Colors = exports.Colors || (exports.Colors = {}));
var Fonts;
(function (Fonts) {
    Fonts["primary"] = "Martel";
    Fonts["secondary"] = "Montserrat";
})(Fonts || (Fonts = {}));
var FontSizes;
(function (FontSizes) {
    FontSizes[FontSizes["xs"] = 12] = "xs";
    FontSizes[FontSizes["sm"] = 14] = "sm";
    FontSizes[FontSizes["base"] = 14] = "base";
    FontSizes[FontSizes["md"] = 24] = "md";
    FontSizes[FontSizes["lg"] = 36] = "lg";
    FontSizes[FontSizes["xl"] = 36] = "xl";
    FontSizes[FontSizes["xxl"] = 36] = "xxl";
})(FontSizes || (FontSizes = {}));
var Patterns;
(function (Patterns) {
    Patterns["primary"] = "primary";
    Patterns["secondary"] = "secondary";
    Patterns["tertiary"] = "tertiary";
    Patterns["quaternary"] = "quaternary";
})(Patterns = exports.Patterns || (exports.Patterns = {}));
var Transitions;
(function (Transitions) {
    Transitions["default"] = "250ms ease-in";
    Transitions["quick"] = "125ms ease-in";
    Transitions["color"] = "color 125ms ease-in";
})(Transitions || (Transitions = {}));
var ZIndexes;
(function (ZIndexes) {
    ZIndexes[ZIndexes["default"] = 1] = "default";
    ZIndexes[ZIndexes["header"] = 10] = "header";
    ZIndexes[ZIndexes["navigation"] = 15] = "navigation";
    ZIndexes[ZIndexes["overlay"] = 50] = "overlay";
    ZIndexes[ZIndexes["modal"] = 75] = "modal";
})(ZIndexes || (ZIndexes = {}));
var Positions;
(function (Positions) {
    Positions["top"] = "top";
    Positions["right"] = "right";
    Positions["center"] = "center";
    Positions["bottom"] = "bottom";
    Positions["left"] = "left";
})(Positions = exports.Positions || (exports.Positions = {}));
exports.cssVars = {
    breakpoints: breakpoints,
    breakpointsArray: exports.breakpointsArray,
    colors: Colors,
    columns: {
        smallBlock: {
            xs: 1,
            md: 10 / 12,
            lg: 8 / 12,
        },
    },
    dist: Dist,
    distances: {
        extraSmall: {
            xs: Dist.xxs,
            sm: Dist.xs,
            lg: Dist.sm,
        },
        small: {
            xs: Dist.sm,
            sm: Dist.sm,
            lg: Dist.md,
        },
        medium: {
            xs: Dist.sm,
            sm: Dist.md,
            lg: Dist.lg,
        },
        large: {
            xs: Dist.md,
            sm: Dist.lg,
            lg: Dist.xl,
        },
        extraLarge: {
            xs: Dist.lg,
            sm: Dist.xl,
            lg: Dist.xxl,
        },
        blockSpacing: {
            xs: Dist.lg,
            sm: Dist.xl,
            lg: Dist.xxl,
        },
        doubleBlockSpacing: {
            xs: Dist.lg * 2,
            sm: Dist.xl * 2,
            lg: Dist.xxl * 2,
        },
        contentInset: {
            xs: -Dist.lg,
            sm: -Dist.xl,
            lg: -Dist.xxl * 1.5,
        },
    },
    fonts: Fonts,
    fontSizes: FontSizes,
    fontSizesConfig: {
        small: {
            xs: FontSizes.sm,
        },
        medium: {
            xs: FontSizes.sm,
            md: FontSizes.md,
        },
        large: {
            xs: FontSizes.md,
            lg: FontSizes.lg,
        },
        default: {
            xs: FontSizes.base,
        },
        h1: {
            xs: 34,
            sm: 52,
            lg: 60,
        },
        h2: {
            xs: 32,
            sm: 36,
            lg: 42,
        },
        h3: {
            xs: 28,
            sm: 32,
            lg: 36,
        },
        h4: {
            xs: 18,
            sm: 22,
            lg: 24,
        },
        h5: {
            xs: 18,
            sm: 19,
            lg: 20,
        },
        h6: {
            xs: FontSizes.sm,
            sm: 15,
            lg: 16,
        },
    },
    grid: {
        gutter: gutter,
        width: Breakpoints,
    },
    heights: {
        secondaryHeaderHeight: {
            xs: 26,
        },
        primaryHeaderHeight: {
            xs: 74,
        },
        headerHeight: {
            xs: 100,
        },
        bannerHeight: {
            xs: 440,
            md: 500,
            lg: 600,
        },
        patternBannerHeight: {
            xs: 200,
            sm: 300,
            md: 350,
            lg: 400,
        },
    },
    positions: Positions,
    pushConfigs: {},
    transitions: Transitions,
    zIndexes: ZIndexes,
};
